import { inject, Injectable } from '@angular/core';
import {
  ContractorAvailabilityDto,
  ContractorAvailabilityException,
  CreateContractorAvailabilityException,
  IContractorAvailabilityDataService,
  PagedResultDto,
  Shift,
  ShiftsService
} from '@umss/shared/data-access';
import { getMonthRange } from '@umss/shared/utils';
import { map, Observable } from 'rxjs';
import { ContractorService } from './contractor.service';

@Injectable({ providedIn: 'root' })
export class ContractorSelfAvailabilityDataService implements IContractorAvailabilityDataService {
  readonly contractorService = inject(ContractorService);
  readonly shiftsService = inject(ShiftsService);
  readonly availabilityUpdated$ = this.contractorService.availabilityUpdated$;

  getAvailability(): Observable<ContractorAvailabilityDto[]> {
    return this.contractorService.getMyAvailability();
  }

  getAvailabilityExceptions(
    _contractorId?: string,
    params?: { startDate: string; endDate: string }
  ): Observable<ContractorAvailabilityException[]> {
    return this.contractorService.getMyAvailabilityExceptions(params);
  }

  getShiftsForMonth(year: number, month: number): Observable<Shift[]> {
    const { startDate, endDate } = getMonthRange(year, month);

    return this.shiftsService
      .getContractorShifts({
        startDate,
        endDate,
        pageSize: 100
      })
      .pipe(map((response: PagedResultDto<Shift>) => response.items || []));
  }

  createAvailabilityException(
    exception: CreateContractorAvailabilityException
  ): Observable<ContractorAvailabilityException> {
    return this.contractorService.createMyAvailabilityException(exception);
  }

  deleteAvailabilityException(exceptionId: number): Observable<void> {
    return this.contractorService.deleteMyAvailabilityException(exceptionId);
  }
}
